import { FunctionComponent, ReactNode } from 'react';
import { FieldRevertContext } from './FieldRevertContext';

interface IFieldRevertProviderProps {
  enabled: boolean;
  children: ReactNode;
}

export const FieldRevertProvider: FunctionComponent<IFieldRevertProviderProps> = ({ enabled, children }) => (
  <FieldRevertContext.Provider value={enabled}>
    {children}
  </FieldRevertContext.Provider>
);
